import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-39d12b3a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "question-list-view"
};
const _hoisted_2 = {
  class: "qlist-topbar"
};
const _hoisted_3 = {
  class: "qlist-subtitle"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-topic"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-emoji"
}, "🌈", -1));
const _hoisted_6 = {
  class: "qlist-header"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "orderNo"
}, "按编号排序", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "difficulty"
}, "按难度排序", -1));
const _hoisted_9 = [_hoisted_7, _hoisted_8];
const _hoisted_10 = {
  class: "qlist-main"
};
const _hoisted_11 = {
  key: 0,
  class: "qlist-empty"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-empty"
}, null, -1));
const _hoisted_13 = {
  key: 1,
  class: "qlist-cards"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "qlist-id"
};
const _hoisted_16 = {
  class: "qlist-card-right"
};
const _hoisted_17 = {
  key: 0,
  class: "vip-tag"
};
const _hoisted_18 = {
  key: 0,
  class: "qlist-pagination"
};
const _hoisted_19 = ["disabled"];
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-emoji"
}, "🌸", -1));
const _hoisted_21 = {
  class: "qlist-page-numbers"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = ["disabled"];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-emoji"
}, "🌸", -1));
import { ref, computed, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import myAxios from "@/plugins/myAxios";

// 子主题映射表
// const subTopicMap = {
//   'java-basic': 'Java基础',
//   'db': '数据库',
//   'spring': 'Spring框架',
//   'js-basic': 'JavaScript基础',
//   'vue': 'Vue',
//   'css': 'CSS',
//   'web-sec': 'Web安全',
//   'net-protocol': '网络协议',
// };

// // 扩展 mock 数据，增加更多 Java 相关面试题
// const allQuestions = [
//   { id: 1, title: 'Java 基础语法有哪些？', difficulty: 'easy', sub: 'java-basic', vip: false },
//   { id: 2, title: '什么是面向对象？', difficulty: 'easy', sub: 'java-basic', vip: false },
//   { id: 3, title: 'Java 中的集合框架有哪些？', difficulty: 'medium', sub: 'java-basic', vip: true },
//   { id: 4, title: 'HashMap 的工作原理？', difficulty: 'hard', sub: 'java-basic', vip: true },
//   { id: 5, title: 'Java 异常处理机制？', difficulty: 'medium', sub: 'java-basic', vip: false },
//   { id: 6, title: 'Java 中的多线程如何实现？', difficulty: 'hard', sub: 'java-basic', vip: true },
//   { id: 7, title: 'Java 中的 final 关键字作用？', difficulty: 'easy', sub: 'java-basic', vip: false },
//   { id: 8, title: 'Java 泛型的工作原理？', difficulty: 'medium', sub: 'java-basic', vip: true },
//   { id: 9, title: 'Java 中的 synchronized 关键字？', difficulty: 'hard', sub: 'java-basic', vip: true },
//   { id: 10, title: 'Java 反射机制是什么？', difficulty: 'hard', sub: 'java-basic', vip: true },
//   { id: 11, title: 'MySQL 索引的作用？', difficulty: 'medium', sub: 'db', vip: true },
//   { id: 12, title: 'Spring IOC 和 AOP 区别？', difficulty: 'medium', sub: 'spring', vip: true },
//   { id: 13, title: 'ES6 新特性有哪些？', difficulty: 'easy', sub: 'js-basic', vip: false },
//   { id: 14, title: 'Vue 生命周期有哪些？', difficulty: 'medium', sub: 'vue', vip: true },
//   { id: 15, title: '什么是 BFC？', difficulty: 'medium', sub: 'css', vip: false },
//   { id: 16, title: 'XSS 攻击原理？', difficulty: 'hard', sub: 'web-sec', vip: true },
//   { id: 17, title: 'TCP 和 UDP 区别？', difficulty: 'easy', sub: 'net-protocol', vip: false },
//   { id: 18, title: 'Redis 的数据类型有哪些？', difficulty: 'medium', sub: 'db', vip: true },
//   { id: 19, title: 'Spring Boot 的特点？', difficulty: 'easy', sub: 'spring', vip: false },
//   { id: 20, title: 'Promise 的使用方法？', difficulty: 'medium', sub: 'js-basic', vip: true },
//   { id: 21, title: 'Vue Router 的导航守卫？', difficulty: 'hard', sub: 'vue', vip: true },
//   { id: 22, title: 'CSS Grid 和 Flex 区别？', difficulty: 'medium', sub: 'css', vip: false },
//   { id: 23, title: 'SQL 注入如何防范？', difficulty: 'hard', sub: 'web-sec', vip: true },
//   { id: 24, title: 'HTTP 状态码含义？', difficulty: 'easy', sub: 'net-protocol', vip: false },
//   { id: 25, title: 'MongoDB 的优势？', difficulty: 'medium', sub: 'db', vip: true },
//   { id: 26, title: 'Spring MVC 工作流程？', difficulty: 'hard', sub: 'spring', vip: true },
//   { id: 27, title: 'JavaScript 闭包是什么？', difficulty: 'medium', sub: 'js-basic', vip: true },
//   { id: 28, title: 'Vuex 状态管理原理？', difficulty: 'hard', sub: 'vue', vip: true },
//   { id: 29, title: 'CSS 选择器优先级？', difficulty: 'easy', sub: 'css', vip: false },
//   { id: 30, title: 'CSRF 攻击原理？', difficulty: 'hard', sub: 'web-sec', vip: true },
// ];
const pageSize = 8;

// 监听路由变化，切换子主题时重置页码

export default {
  __name: 'InterviewQuestionList',
  setup(__props) {
    const allQuestions = ref([]); // 修改为响应式数组

    // 获取面试题列表数据
    const getTagQuestions = async subKey => {
      try {
        const res = await myAxios.get('/baseinfo/fronted/getInterViewQuestionsById', {
          params: {
            profileId: subKey
          }
        });
        if (res.data.code === 200) {
          // 处理返回的数据
          const processedData = res.data.data.map(item => ({
            id: item.id,
            title: item.name,
            difficulty: item.difficult || 'medium',
            // 设置默认难度
            sub: item.profileId,
            vip: item.isFree === 1,
            // 转换vip状态为布尔值
            orderNo: item.orderNo || 0
          }));
          allQuestions.value = processedData;
        } else {
          console.warn('获取面试题列表失败:', res.data.msg);
          allQuestions.value = []; // 清空数据
        }
      } catch (error) {
        console.error('获取面试题列表出错:', error);
        allQuestions.value = []; // 出错时清空数据
      }
    };

    // 在组件挂载时获取数据
    onMounted(() => {
      getTagQuestions(subKey.value);
    });
    const route = useRoute();
    const router = useRouter();
    const subKey = ref(route.params.id || '');
    const subName = ref(route.params.name || '');
    const searchKeyword = ref('');
    const sortKey = ref('orderNo');
    const page = ref(1);
    watch(() => route.params.id, val => {
      subKey.value = val || '';
      page.value = 1;
    });

    // 计算子主题标签
    const subTopicLabel = computed(() => subName.value || '未知主题');

    // 过滤和排序题目
    const filteredQuestions = computed(() => {
      let list = allQuestions.value.filter(q => q.sub === parseInt(subKey.value));
      if (searchKeyword.value.trim()) {
        list = list.filter(q => q.title.toLowerCase().includes(searchKeyword.value.trim().toLowerCase()));
      }
      if (sortKey.value === 'difficulty') {
        const diffOrder = {
          easy: 1,
          medium: 2,
          hard: 3
        };
        list = list.slice().sort((a, b) => diffOrder[a.difficulty] - diffOrder[b.difficulty]);
      } else {
        list = list.slice().sort((a, b) => a.orderNo - b.orderNo);
      }
      return list;
    });

    // 计算分页
    const totalPages = computed(() => Math.ceil(filteredQuestions.value.length / pageSize));
    const pagedQuestions = computed(() => {
      const start = (page.value - 1) * pageSize;
      // 添加序号字段
      return filteredQuestions.value.slice(start, start + pageSize).map((q, index) => ({
        ...q,
        serialNumber: start + index + 1 // 添加从1开始的序号
      }));
    });

    // 搜索时重置页码
    function onSearch() {
      page.value = 1;
    }

    // 跳转到题目详情
    function goToDetail(q) {
      router.push(`/business/interview/question/${subKey.value}/${subName.value}/${q.id}`);
    }

    // 返回上一页
    function goBack() {
      router.push('/business/interview');
    }

    // 难度标签
    function difficultyLabel(diff) {
      const labels = {
        easy: '简单',
        medium: '中等',
        hard: '困难'
      };
      return labels[diff] || diff;
    }

    // 难度图标
    function getDifficultyIcon(diff) {
      const icons = {
        easy: 'iconfont icon-smile',
        medium: 'iconfont icon-neutral',
        hard: 'iconfont icon-frown'
      };
      return icons[diff] || '';
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, [_hoisted_4, _createTextVNode(" " + _toDisplayString(subTopicLabel.value), 1)]), _createElementVNode("button", {
        class: "qlist-back",
        onClick: goBack
      }, [_hoisted_5, _createTextVNode(" 返回面试题主页 ")])]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
        class: "qlist-search",
        placeholder: "搜索题目关键字...",
        onInput: onSearch
      }, null, 544), [[_vModelText, searchKeyword.value]]), _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => sortKey.value = $event),
        class: "qlist-sort"
      }, _hoisted_9, 512), [[_vModelSelect, sortKey.value]])]), _createElementVNode("div", _hoisted_10, [filteredQuestions.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_hoisted_12, _createTextVNode(" 暂无题目 ")])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagedQuestions.value, q => {
        return _openBlock(), _createElementBlock("div", {
          key: q.id,
          class: "qlist-card"
        }, [_createElementVNode("div", {
          class: "qlist-title",
          onClick: $event => goToDetail(q)
        }, [_createElementVNode("span", _hoisted_15, "#" + _toDisplayString(q.serialNumber), 1), _createTextVNode(" " + _toDisplayString(q.title), 1)], 8, _hoisted_14), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
          class: _normalizeClass(["qlist-difficulty", 'diff-' + q.difficulty])
        }, [_createElementVNode("i", {
          class: _normalizeClass(["difficulty-icon", getDifficultyIcon(q.difficulty)])
        }, null, 2), _createTextVNode(" " + _toDisplayString(difficultyLabel(q.difficulty)), 1)], 2), q.vip ? (_openBlock(), _createElementBlock("span", _hoisted_17, "VIP")) : _createCommentVNode("", true)])]);
      }), 128))]))]), totalPages.value > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("button", {
        disabled: page.value === 1,
        onClick: _cache[2] || (_cache[2] = $event => page.value--),
        class: "pagination-btn prev-btn"
      }, [_hoisted_20, _createTextVNode(" 上一页 ")], 8, _hoisted_19), _createElementVNode("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, p => {
        return _openBlock(), _createElementBlock("button", {
          key: p,
          class: _normalizeClass({
            'qlist-page-active': p === page.value
          }),
          onClick: $event => page.value = p
        }, _toDisplayString(p), 11, _hoisted_22);
      }), 128))]), _createElementVNode("button", {
        disabled: page.value === totalPages.value,
        onClick: _cache[3] || (_cache[3] = $event => page.value++),
        class: "pagination-btn next-btn"
      }, [_createTextVNode(" 下一页 "), _hoisted_24], 8, _hoisted_23)])) : _createCommentVNode("", true)]);
    };
  }
};